import React, { Component } from "react";
import { Button, Col, Image, Row } from "react-bootstrap";
// import Aadhaar from "./Aadhaar.png";
// import Mobile from "./mobile.png";

import "./Abha.css";

export default class Abhacreation extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  handleSubmitABHANumber = (e) => {
    window.location.href = "/abhanumberverification";
  };
  handleSubmitMobile = (e) => {
    window.location.href = "/abhaaddressverification";
  };
  render() {
    return (
      <div>
        <Row className="justify-content-evenly align-items-center createAbhaNumber">
          
          <Col className="text-center card p-3" md={4}>
            <div className="card-body">
              {/* <Image
                src={Aadhaar}
                alt=""
                style={{
                  width: "auto",
                  height: "80px",
                }}
              /> */}
              <p>Register with ABHA Number</p>
              <Button className="rounded-1" onClick={this.handleSubmitABHANumber}>
                ABHA Number
              </Button>
            </div>
          </Col>
          <Col className="text-center card p-3" md={4}>          
            <div className="card-body">
              {/* <Image
                src={Mobile}
                alt=""
                style={{
                  width: "auto",
                  height: "80px",
                }}
              /> */}
              <p>Login With ABHA Address</p>
              <Button className="rounded-1" onClick={this.handleSubmitMobile}>
               ABHA Address
              </Button>
              </div>
          </Col>
        </Row>
      </div>
    );
  }
}
